import { render, staticRenderFns } from "./SubscriberAvatarEditor.vue?vue&type=template&id=c4dbf480&"
import script from "./SubscriberAvatarEditor.vue?vue&type=script&lang=js&"
export * from "./SubscriberAvatarEditor.vue?vue&type=script&lang=js&"
import style0 from "./SubscriberAvatarEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports